export default [
    {
      title: 'แดชบอร์ด',
      route: 'admin-dashboard',
      icon: 'HomeIcon',
      resource: 'TaobaoAdmin',
      action: 'manage',
    },
    {
      title: 'ข้อมูลลูกค้า',
      route: 'admin-customer',
      icon: 'UserIcon',
      resource: 'TaobaoAdmin',
      action: 'manage',
    },
    // {
    //   title: 'อัปโหลด',
    //   route: 'admin-upload',
    //   icon: 'UploadIcon',
    //   resource: 'TaobaoAdmin',
    //   action: 'manage',
    // },
  ]